import { InspectionSelectionItemLoader } from "@/inspection/shared/dtos/InspectionDomainSelectionItemLoader";
import { Form } from "@/shared/form/Form";
import {
  FormFieldDefinition,
  FormFieldType
} from "@/shared/form/FormDefinition";

/**
 * Per-report report settings of the existing PDF report (B1300).
 *
 * The keys are the keys the report renderer reads from the report `settings`
 * blob, so they are intentionally not camel-cased throughout.
 */
export interface ReportSettingsFormData {
  hidePages: boolean;
  hideChecklist: boolean;
  skip_actions: boolean;
  tickets_title: string;
  ticket_headlines: string;
  priorityFilter: string[];
  hidden_ticket_ids: number[];
}

/**
 * A definition that has to carry exactly one entry per data field, so the data
 * interface above and the rendered fields cannot drift apart.
 */
type ReportSettingsDefinition = {
  [key in keyof ReportSettingsFormData]: FormFieldDefinition<
    ReportSettingsFormData
  >;
};

/** Three columns from the large breakpoint up, two from the small one. */
const settingsColumn = { width: "6", lgWidth: "4" };

export class ReportSettingsForm extends Form<ReportSettingsFormData> {
  protected definition: ReportSettingsDefinition = {
    hidePages: {
      label: "Seitenanzahl ausblenden",
      required: false,
      type: FormFieldType.Checkbox,
      ...settingsColumn
    },
    hideChecklist: {
      label: "Checkliste ausblenden",
      required: false,
      type: FormFieldType.Checkbox,
      ...settingsColumn
    },
    skip_actions: {
      label: "Maßnahmenkatalog ausblenden",
      required: false,
      type: FormFieldType.Checkbox,
      ...settingsColumn
    },
    tickets_title: {
      label: "Kapitelüberschrift Fotodokumentation",
      required: false,
      type: FormFieldType.Text,
      ...settingsColumn
    },
    ticket_headlines: {
      label: "Kapitelstruktur Fotodokumentation",
      required: false,
      type: FormFieldType.Selection,
      ...settingsColumn,
      itemDefinition: {
        items: () => {
          return [
            {
              text: "Nur erste Checklisten-Hierarchieebene (B1300)",
              value: ""
            },
            {
              text: "Gesamte Checklisten-Hierarchie",
              value: "sections_entries"
            }
          ];
        }
      }
    },
    priorityFilter: {
      label: "Prioritätenfilter",
      required: false,
      type: FormFieldType.MultiSelect,
      ...settingsColumn,
      itemDefinition: {
        items: () => {
          return InspectionSelectionItemLoader.loadPriorities();
        }
      }
    },
    // edited through the ticket selection dialog, never as a grid field
    hidden_ticket_ids: {
      label: "Ausgeblendete Tickets",
      required: false,
      type: FormFieldType.MultiSelect,
      defaultValue: [],
      hidden: true
    }
  };
}
